<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  clearable
                  @keyup.enter="SearchChannelList"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
                  style="width: 120px"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="SearchChannelList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>

          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column
            align="center"
            fixed
            label="序号"
            type="index"
            width="100"
        >
          <template slot-scope="scope">
                <span>{{
                    (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="channelType"
            label="标识"
            width="120"
            align="center"
        >
        </el-table-column>
        <el-table-column prop="mchId" label="icon" width="200" align="center">
          <template slot-scope="scope">
            <img
                :src="scope.row.icon"
                alt=""
                style="width: 20px; height: 20px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="200" align="center">
        </el-table-column>

        <el-table-column prop="descr" label="说明" width="200" align="center">
        </el-table-column>
        <el-table-column prop="code" v-if="userInfo && userInfo.operateStatus==1" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <template v-if="numType">
              <el-switch
                  :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row)"
              >
              </el-switch>
            </template>
            <template v-else>
              <el-switch
                  :disabled="statusShow"
                  :value="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="operationShowTime"
              >
              </el-switch>
            </template>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="150" fixed='right'>
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="warning"
                plain
                v-if="editShow"
            >编辑
            </el-button
            >
            <template v-if="deleteShow && userInfo && userInfo.operateStatus==1">
              <el-button
                  size="mini"
                  @click="handleDelete(scope.row)"
                  type="primary"
                  plain
                  v-if="numType && deleteShow"
              >删除
              </el-button
              >
              <el-button
                  size="mini"
                  @click="operationShowTime"
                  type="primary"
                  plain
                  v-if="!numType && deleteShow"
              >删除
              </el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="渠道信息"
        :visible.sync="dialogVisible"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="图标" prop="icon">
            <!--图片部分-->
            <div class="screenshot">
              <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
              >
                <div
                    class="icon-close"
                    @click="removeUploading(index)"
                    v-if="isMoer"
                >
                  <i class="el-icon-close"></i>
                </div>
                <el-image
                    style="width: 85px; height: 85px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy"
                />
              </span>
              <div
                  class="up-btn"
                  style="width: 85px; height: 85px; line-height: 85px"
                  @click="getPolicy"
                  v-if="isMoer"
              >
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <input type="file" ref="file" @change="getFile"/>
          </el-form-item>

          <el-form-item label="标识" prop="channelType">
            <el-input
                placeholder="请填写标识"
                v-model="params.channelType"
                :disabled="clickType=='edit'"
            ></el-input>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input placeholder="请填写名称" v-model="params.name"></el-input>
          </el-form-item>

          <el-form-item label="说明" prop="descr">
            <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <operation-confirmation @closeOperation="publicMethios"
                            :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";
import {isEmpty} from '../../utils/tools';
import {ossUpload} from "@utils/filters/upload";
import OperationConfirmation from "../../components/OperationConfirmation";

export default {
  components: {OperationConfirmation},
  data() {
    return {
      clickType: '',
      listParams: {},
      params: {},
      tableData: [],
      dialogVisible: false,
      total: 0,
      PAGE_SIZE,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      loading: false,
      rules: {
        channelType: [
          {required: true, message: "请填写标识", trigger: "change"},
        ],
        name: [{required: true, message: "请填写名称", trigger: "change"}],
        // descr: [{ required: true, message: "请填写说明", trigger: "change" }],
        seq: [{message: "请填写序号", trigger: "change"}],
      },
      srcList: [],
      isMoer: true,
      imgUrl: [],
      operationVisible: false,
      numType: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  created() {
    if (window.sessionStorage.getItem('operationKey')) {
      this.numType = true
    }
    this.queryTableData();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = []
        this.isMoer = true
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'channel:type:query') {
            this.searchShow = true
          }
          if (item.code == 'channel:type:add') {
            this.addShow = true
          }
          if (item.code == "channel:type:delete") {
            this.deleteShow = true
          }
          if (item.code == "channel:type:edit") {
            this.editShow = true
          }
          if(item.code == "channel:type:status"){
            this.statusShow = false
          }
        })
      }
    },
    //清楚缓存数据，重启密码验证
    clearStore() {
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e) {
      this.operationVisible = false
      if (e == 'open') {
        this.numType = true
        setTimeout(() => {
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        }, 1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true
    },
    SearchChannelList() {
      this.pages.pageNo = 1
      this.queryTableData()
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("channel/type/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },
    /**
     * 修改渠道类型状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `channel/type/info/status/${b.channelType}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
      this.clearStore()
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        this.params = JSON.parse(JSON.stringify(row));
        if (!isEmpty(row.icon)) {
          this.srcList[0] = row.icon
          this.isMoer = false
        }
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "channel/type/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "channel/type/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `channel/type/info/${row.channelType}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
      this.clearStore()
    },

    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one" //'more','one'
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },
    removeUploading(index) {
      this.srcList.splice(index, 1);
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped="">
</style>